import { NgModule } from "@angular/core";
import { StarterViewComponent } from "./customerviews/starterview.component";
import { ModalModule } from 'angular2-modal';
import { LoginModule } from "./account/login.module";
import { LoyaltySiteModule } from "./admin/loyalty-site/loyalty-site.module";
import { TransactionLogModule } from "./admin/transaction-log/transaction-log.module";
import { UserModule } from "./admin/user/user.module";
import { CustomerModule } from "./admin/customer/customer.module";
import { FraudReportsSiteModule} from "./admin/fraud-reports/fraud-reports.module";
import { AuditReportSiteModule} from "./admin/audit-report/audit-report.module";
import { ProfileModule } from "./account/profile/profile.module";
import { BootstrapModalModule, BSMessageModal } from "angular2-modal/plugins/bootstrap";
import { AgmCoreModule } from "@agm/core";


@NgModule({
    declarations: [
        StarterViewComponent
    ],
    imports: [
        BootstrapModalModule,
        ModalModule.forRoot(),
        LoginModule,
        ProfileModule,
        LoyaltySiteModule,
        TransactionLogModule,
        UserModule,
        CustomerModule,
        FraudReportsSiteModule,
        AuditReportSiteModule,
       AgmCoreModule

    ],
    entryComponents: [
        BSMessageModal
    ],
    exports:[
       AgmCoreModule
    ]
})

export class AppviewsModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/appviews.module.ts